module.exports = __webpack_public_path__ + "media/images/companies/mizuho_capital-4235082b6f6fcace0812758869d48351.png";